import { useContext } from 'react';
import { ConfigContext } from '../../providers/ConfigContext';

// Redirects to Host Hub Homepage
const RedirectPage = () => {
	const { bookfairs } = useContext(ConfigContext);
	window.location.href = `${bookfairs}/content/fairs/hub/home.html`;
	return null;
};

export default RedirectPage;
